export function getAffiliatePageStyles(isMobile, isSmallMobile) {
  return {
    mainWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      minHeight: '100vh',
      width: '100%',
      backgroundColor: 'transparent',
      padding: isSmallMobile ? '0' : isMobile ? '15px' : '20px',
      fontFamily: 'Inter, sans-serif',
      boxSizing: 'border-box',
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      maxWidth: '1200px',
      backgroundColor: 'transparent',
      padding: isSmallMobile ? '15px' : '20px',
      boxSizing: 'border-box',
    },
    headerRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: isMobile ? 'flex-start' : 'center',
      flexDirection: isMobile ? 'column' : 'row',
      gap: isMobile ? '12px' : '0',
      marginBottom: isSmallMobile ? '15px' : '20px',
    },
    headerTitle: {
      fontSize: isSmallMobile ? '18px' : isMobile ? '20px' : '22px',
      color: '#000',
      margin: 0,
      fontWeight: 'bold',
    },
    breadcrumbs: {
      fontSize: '12px',
      color: '#6b7280',
      marginTop: '4px',
    },
    primaryButton: {
      backgroundColor: '#D4AF37',
      color: '#000',
      border: 'none',
      borderRadius: '5px',
      padding: '10px 18px',
      cursor: 'pointer',
      fontSize: '13px',
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      transition: 'opacity 0.2s ease',
    },
    secondaryButton: {
      backgroundColor: 'transparent',
      color: '#D4AF37',
      border: '1px solid #D4AF37',
      borderRadius: '5px',
      padding: '8px 14px',
      cursor: 'pointer',
      fontSize: '12px',
      fontWeight: '600',
    },
    dangerButton: {
      backgroundColor: 'transparent',
      color: '#f87171',
      border: '1px solid #f87171',
      borderRadius: '5px',
      padding: '8px 14px',
      cursor: 'pointer',
      fontSize: '12px',
      fontWeight: '600',
      transition: 'opacity 0.2s ease',
    },
    contentContainer: {
      backgroundColor: '#000',
      borderRadius: '10px',
      padding: isSmallMobile ? '15px' : '20px',
      color: '#E5D0A5',
    },
    toolbar: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '15px',
      flexDirection: isSmallMobile ? 'column' : 'row',
      gap: '12px',
    },
    searchBar: {
      flexGrow: 1,
      minWidth: isMobile ? '100%' : '220px',
      maxWidth: isMobile ? '100%' : '400px',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'transparent',
      borderRadius: '24px',
      border: '1px solid #D4AF37',
      padding: '10px 18px',
      height: '46px',
      boxSizing: 'border-box',
    },
    searchIcon: {
      color: '#D4AF37',
      fontSize: '14px',
      marginRight: '10px',
      flexShrink: 0,
    },
    searchInput: {
      backgroundColor: 'transparent',
      border: 'none',
      outline: 'none',
      color: '#E5D0A5',
      fontSize: '14px',
      flexGrow: 1,
      width: '100%',
    },
    filterSelect: {
      backgroundColor: 'transparent',
      color: '#E5D0A5',
      border: '1px solid #D4AF37',
      borderRadius: '24px',
      padding: '10px 16px',
      fontSize: '13px',
      outline: 'none',
      cursor: 'pointer',
      minWidth: isMobile ? '100%' : '150px',
      height: '46px',
    },
    tableWrapper: {
      overflowX: 'auto',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      minWidth: isMobile ? '900px' : '1000px',
    },
    th: {
      padding: '14px 10px',
      textAlign: 'left',
      borderBottom: '1px solid #333',
      fontSize: '12px',
      fontWeight: '600',
      color: '#D4AF37',
      whiteSpace: 'nowrap',
    },
    td: {
      padding: '14px 10px',
      verticalAlign: 'middle',
      fontSize: '12px',
      borderBottom: '1px solid #333',
      color: '#E5D0A5',
    },
    emptyCell: {
      padding: '24px 10px',
      textAlign: 'center',
      color: '#9ca3af',
      fontSize: '13px',
    },
    statusActive: { color: '#4ade80', fontWeight: '600' },
    statusInactive: { color: '#9ca3af', fontWeight: '600' },
    statusSuspended: { color: '#f87171', fontWeight: '600' },
    actionGroup: {
      display: 'flex',
      gap: '8px',
      flexWrap: 'wrap',
    },
    formSection: {
      backgroundColor: '#000',
      borderRadius: '10px',
      padding: isSmallMobile ? '18px' : '25px',
      color: '#E5D0A5',
      display: 'grid',
      gap: '16px',
    },
    formGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '6px',
    },
    formLabel: {
      fontSize: '13px',
      fontWeight: '600',
      color: '#D4AF37',
    },
    formInput: {
      width: '100%',
      padding: '11px 12px',
      borderRadius: '6px',
      border: '1px solid #333',
      backgroundColor: '#1a1a1a',
      color: '#E5D0A5',
      fontSize: '14px',
      outline: 'none',
      boxSizing: 'border-box',
    },
    formGrid2: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
      gap: '14px',
    },
    statsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
      gap: '12px',
      marginBottom: '20px',
    },
    statCard: {
      backgroundColor: '#1a1a1a',
      border: '1px solid #333',
      borderRadius: '8px',
      padding: '14px',
    },
    statLabel: {
      fontSize: '11px',
      color: '#9ca3af',
      marginBottom: '6px',
      textTransform: 'uppercase',
      letterSpacing: '0.04em',
    },
    statValue: {
      fontSize: '16px',
      fontWeight: '700',
      color: '#D4AF37',
    },
    profileCard: {
      backgroundColor: '#1a1a1a',
      border: '1px solid #333',
      borderRadius: '10px',
      padding: '20px',
      marginBottom: '20px',
    },
    profileTitle: {
      fontSize: '18px',
      fontWeight: '700',
      color: '#D4AF37',
      marginBottom: '12px',
    },
    profileRow: {
      fontSize: '13px',
      color: '#E5D0A5',
      marginBottom: '8px',
      lineHeight: 1.5,
    },
    sectionTitle: {
      fontSize: '15px',
      fontWeight: '700',
      color: '#000',
      marginBottom: '12px',
    },
  };
}
